import { useGeneratorContext } from '@Context/GeneratorContext';
import { SquaresFour } from '@phosphor-icons/react';
import { MoonLoader } from 'react-spinners';
import { useEffect, useState } from 'react';
import SubtaskItems from './SubtaskItems';

const Subtasks = () => {
  const {
    issueDescrips,
    selectedJiraIssue,
    selectedJiraProject,
    fetchIssueDescrips,
  } = useGeneratorContext();

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (selectedJiraIssue) {
      setLoading(true);
      fetchIssueDescrips(selectedJiraIssue.key).then(() => {
        setLoading(false);
      });
    }
  }, [selectedJiraIssue]);

  return (
    <>
      <div
        data-testid="test-requirements"
        className="flex h-full w-full flex-col rounded-lg bg-white"
      >
        {/* NO PROD */}
        {!selectedJiraProject && !selectedJiraIssue && (
          <span className="flex h-full flex-col items-center justify-center text-neutral-300">
            <SquaresFour size={100} weight="bold" />
            <label className="text-sm text-neutral-500">
              Select a project first
            </label>
          </span>
        )}

        {/* NO FEAT */}
        {!selectedJiraIssue && selectedJiraProject && (
          <span className="flex h-full flex-col items-center justify-center text-neutral-300">
            <SquaresFour size={100} weight="bold" />
            <label className="text-sm text-neutral-500">
              Select an issue first
            </label>
          </span>
        )}

        {/* NO FEAT DESCRIPT */}
        {!loading && selectedJiraIssue && issueDescrips.length === 0 && (
          <span className="flex h-full flex-col items-center justify-center text-neutral-300">
            <SquaresFour size={150} weight="bold" />
            <label className="text-sm text-neutral-500">No Description</label>
          </span>
        )}

        {loading ? (
          <span className="flex h-full w-full flex-col items-center justify-center sm:gap-y-6 sm:p-5">
            <MoonLoader color="#071D49" />
            <span className="animate-pulse text-xs font-semibold tracking-wide text-gray-600 sm:text-sm">
              Feature Description Loading
            </span>
          </span>
        ) : (
          <>
            {/* HAS FEAT DESCRIPT */}
            {issueDescrips && issueDescrips.length > 0 && (
              <div className="flex h-full w-full flex-col gap-y-3 p-4">
                {/* HEADER */}
                <div className="flex flex-row items-center gap-x-2">
                  <div className="rounded-md bg-primary-700 px-2 py-1 text-xs text-white">
                    {selectedJiraIssue && selectedJiraIssue.key}
                  </div>
                  <div className="text-xs font-semibold text-gray-700">
                    Feature Description
                  </div>
                </div>

                <div className="border border-gray-200"></div>

                {/* FEAT TITLE */}
                <div className="text-lg font-bold text-primary-700 sm:text-3xl">
                  {selectedJiraIssue && selectedJiraIssue.summary}
                </div>

                <div className="border border-gray-200"></div>
                {/* FEAT CONTENT */}
                <div className="flex h-full w-full flex-col gap-y-2">
                  <label className="text-sm font-semibold text-gray-700">
                    Requirements
                  </label>
                  <SubtaskItems />
                </div>
              </div>
            )}
          </>
        )}
      </div>
    </>
  );
};

export default Subtasks;
